export function overviewSmallSliderAnimation() {
    const $mainHolder = $(".explore");
    const $slowSlider = $mainHolder.find(".slow-slider");
    const $animationHolder = $mainHolder.find(".animation-slider-holder");
    const $window = $(window);
    let translate = 0;
    let translateSpeed = 0.26;
    let lastScrollTop = 0;
    let scrollSpeed = 1.5;

    $window.on("load", function () {
        let animationsLength = $animationHolder.width();
        $animationHolder.clone().appendTo($animationHolder);
        $animationHolder.find(".animation-slider-holder").removeClass("animation-slider-holder").addClass("clone");
        $slowSlider.addClass("go");
        setInterval(function () {
            translate = translate + translateSpeed + scrollSpeed;
            $animationHolder.css({"transform": "translateX(" + -translate + "px)"});
            if (translate >= animationsLength + 50) {
                $animationHolder.addClass("transition-off");
                translate = 0;
                setTimeout(function () {
                    $animationHolder.removeClass("transition-off");
                },100);
            }
        }, 100);
        StickyAnimation();
    });

    $window.on("scroll", function () {
        if ($window.innerWidth() >= 1200) {
            StickyAnimation();
        }
    });

    function StickyAnimation() {
        let top = $mainHolder.offset().top;
        let $mainHolderHeight = $mainHolder.innerHeight();
        let winScrollTop = $window.scrollTop();
        if (winScrollTop > top - $window.innerHeight() * 0.2 && winScrollTop < top + $mainHolderHeight / 1.3) {

            if ($window.innerWidth() >= 1200) {
                if (winScrollTop > lastScrollTop) {
                    scrollSpeed = winScrollTop * 0.002;
                    $animationHolder.addClass("speed-animate");
                } else {
                    scrollSpeed = winScrollTop * 0.002;
                    $animationHolder.addClass("speed-animate");
                }
                setTimeout(function () {
                    if (winScrollTop === lastScrollTop) {
                        scrollSpeed = 1.5;
                        $animationHolder.removeClass("speed-animate");
                    }
                }, 100);
                lastScrollTop = winScrollTop;
            }
        }
    }
}


// WEBPACK FOOTER //
// ./assets/js/modules/overviewSmallSliderAnimation.js